let domain = "";
// only when you want to access your app on mobile on local network set domain to - http://192.168.0.158:5000
// else leave above domain variable to emprty string/
// let domain = "enter manual domain here"

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  // dev code
  domain = "http://localhost:5001";
} else {
  console.log(process.env.NODE_ENV);

  domain = "https://api.foodiepenguin.com";
  // production code
}

module.exports = domain;
